import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AdminWorks from './AdminWorks';
import AdminProfile from './AdminProfile';
import AdminActivities from './AdminActivities';
import AdminOrder from './AdminOrder';

const TABS = [
  { id: 'works', label: '作品管理' },
  { id: 'profile', label: '書家について' },
  { id: 'activities', label: '活動' },
  { id: 'order', label: 'オーダー' },
];

export default function AdminDashboard() {
  const { logout } = useAuth();
  const [tab, setTab] = useState('works');

  return (
    <div className="admin-dashboard">
      <header className="admin-dashboard__header">
        <p className="admin-dashboard__title">虹嶺庵 管理画面</p>
        <button className="admin-dashboard__logout" onClick={logout}>ログアウト</button>
      </header>

      <nav className="admin-dashboard__tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`admin-dashboard__tab ${tab === t.id ? 'admin-dashboard__tab--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {tab === 'works' && <AdminWorks />}
      {tab === 'profile' && <AdminProfile />}
      {tab === 'activities' && <AdminActivities />}
      {tab === 'order' && <AdminOrder />}
    </div>
  );
}
